"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useABTestsContext = exports.ABTestsContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
exports.ABTestsContext = (0, react_1.createContext)({});
function useABTestsContext() {
    const context = react_1.default.useContext(exports.ABTestsContext);
    if (context.constructor === Object && Object.keys(context).length === 0) {
        throw new Error('useABTestsContext must be used within a ABTestsProvider');
    }
    return context;
}
exports.useABTestsContext = useABTestsContext;
//# sourceMappingURL=abtests-context.js.map